import Header from "@/components/Header";
import { useContent } from "@/hooks/useContent";

const DEFAULT_PRIVACY = `<p>Welcome to our booking platform (the "Platform" or "We"). The Platform allows guests or tenants to perform online booking or reservations of properties and rooms (the "Service"). This privacy policy (the "Policy") outlines our privacy practices with respect to the Service, including the ways your personal information and data are collected, stored, used and shared.</p>

<h2>What kind of personal information is collected?</h2>
<p>When you submit an inquiry, make a customer service request or register an account, you provide contact information such as your name, address, mobile phone number and email address. We may collect your credit card or debit card information when you pay for the Service. This information is collected on our behalf by a payment processor.</p>
<p>We may use cookies and similar tracking technologies to collect information on our website, and via email. Additionally, We may collect your IP address from your internet service provider and may collect your bank details upon property owners' need.</p>

<h2>Use &amp; Disclosure of collected information</h2>
<p>We may share the information you shared with us with third party service providers in order to provide and support the Service:</p>
<ul>
<li>Communicating with you regarding the use of the Service and respond to your requests</li>
<li>Enhancing the security and safety of the Service</li>
<li>Developing new tools, products or services within the Service</li>
<li>Conducting data and system analytics, including research to improve the Service</li>
<li>Comply with any applicable law and assisting law enforcement agencies and competent authorities</li>
</ul>

<h2>Your Rights</h2>
<p>You have the following rights with respect to your personal data:</p>
<ul>
<li>The right to request a copy of your personal data</li>
<li>The right to request to correct your personal data if inaccurate or out of date</li>
<li>The right to request that your personal data be deleted when it is no longer necessary</li>
<li>The right to withdraw any consent to personal data processing at any time</li>
<li>The right to object to the processing of personal data</li>
</ul>

<h2>GDPR Notice</h2>
<p>As a data controller of our clients' personal data, we are committed to protecting and respecting your privacy in compliance with EU-General Data Protection Regulation (GDPR) 2016/679, dated April 27th 2016.</p>

<h2>CCPA Notice</h2>
<p>You may exercise certain consumer rights under the California Consumer Privacy Act (CCPA):</p>
<ul>
<li><strong>Right to Know:</strong> Request information regarding the categories and specific pieces of personal information we have collected</li>
<li><strong>Right to Deletion:</strong> Request that we delete any of your personal information</li>
<li><strong>Right to Non-Discrimination:</strong> We will not deny goods or services for exercising your consumer rights</li>
</ul>

<h2>Children's Privacy</h2>
<p>This service is for people 16 years of age or older. We do not knowingly or intentionally collect information about children who are under 16 years of age.</p>

<h2>Cookies</h2>
<p>We may use cookies on the Service. Cookies are packets of information sent by our servers to your web browser and then sent back by the browser each time it accesses our servers.</p>
<p>You can delete advertising cookies in your browser by using this form: <a href="https://optout.aboutads.info/" target="_blank" rel="noopener noreferrer">https://optout.aboutads.info/</a></p>

<h2>Changes to the Privacy Policy</h2>
<p>We may change this Policy from time to time. We will provide you notice of such changes through the Services' interface. Your continued use of the Service constitutes your consent to the amended Policy.</p>

<h2>Contact Us</h2>
<p>If you have any questions about this Privacy Policy, please contact us:</p>
<p>By email: <a href="mailto:info@kspaceproperties.com">info@kspaceproperties.com</a></p>`;

const Privacy = () => {
  const { content: c } = useContent();
  const privacyHtml = c.privacy_content || DEFAULT_PRIVACY;

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <div className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-heading font-bold text-primary mb-8" data-testid="privacy-title">
            Privacy Policy
          </h1>
          
          <div 
            className="prose max-w-none text-slate-700 space-y-4 [&_h2]:text-2xl [&_h2]:font-heading [&_h2]:font-semibold [&_h2]:text-primary [&_h2]:mt-8 [&_h2]:mb-4 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-2 [&_a]:text-accent [&_a]:hover:underline"
            dangerouslySetInnerHTML={{ __html: privacyHtml }}
            data-testid="privacy-content"
          />
        </div>
      </div>

      <footer className="bg-secondary py-12">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h3 className="text-2xl font-heading font-semibold text-primary mb-4">{c.footer_company || "KSpace Properties"}</h3>
          <p className="text-slate-600 mb-4">{c.footer_email || "info@kspaceproperties.com"}</p>
        </div>
      </footer>
    </div>
  );
};

export default Privacy;
